import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
  mode: 'hash',
  routes: [
    {
      path: '/',
      component: () => import('./views/Admin'),
      redirect: '/admin/home'
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('./views/Login')
    },
    {
      path: '/admin',
      name: 'admin',
      redirect: '/admin/home',
      component: () => import('./views/Admin'),
      children: [
        {
          path: 'home',
          name: '首页',
          component: () => import('./views/home/Home'),
          meta: {
            activeMenu: 'home'
          }
        },
        {
          path: 'instruction',
          name: '操作指南',
          component: () => import('./views/system/Instruction'),
          meta: {
            activeMenu: 'instruction'
          }
        },
        {
          path: 'users',
          name: '学员管理',
          component: () => import('./views/users/Users'),
          children: [
            {
              path: 'studentList',
              name: '学员信息',
              component: () => import('./views/users/StudentList'),
              meta: {
                activeMenu: 'studentList'
              }
            },
            {
              path: 'studentDetails',
              name: '学员详情',
              component: () => import('./views/users/StudentDetails'),
              redirect: '/admin/users/studentDetails/shop',
              meta: {
                activeMenu: 'studentList'
              },
              children: [
                {
                  path: 'shop',
                  name: '店铺就读信息',
                  component: () => import('./views/users/ShopDetails'),
                  meta: {
                    activeMenu: 'studentList'
                  }
                },
                {
                  path: 'order',
                  name: '订单信息',
                  component: () => import('./views/users/OrderDetails'),
                  meta: {
                    activeMenu: 'studentList'
                  }
                },
                {
                  path: 'channel',
                  name: '渠道销售信息',
                  component: () => import('./views/users/ChannelDetails'),
                  meta: {
                    activeMenu: 'studentList'
                  }
                },
                {
                  path: 'point',
                  name: '积分变动详情',
                  component: () => import('./views/users/PointDetails'),
                  meta: {
                    activeMenu: 'studentList'
                  }
                },
                {
                  path: 'attendance',
                  name: '出勤&课耗详情',
                  component: () => import('./views/users/AttendanceDetails'),
                  meta: {
                    activeMenu: 'studentList'
                  }
                },
                {
                  path: 'classes',
                  name: '停课&复课详情',
                  component: () => import('./views/users/ClassesDetials'),
                  meta: {
                    activeMenu: 'studentList'
                  }
                },
                {
                  path: 'historyReport',
                  name: '历史小结详情',
                  component: () => import('./views/users/HistoryReportDetails'),
                  meta: {
                    activeMenu: 'studentList'
                  }
                },
                {
                  path: 'returnVisit',
                  name: '回访记录详情',
                  component: () => import('./views/users/ReturnVisitDetails'),
                  meta: {
                    activeMenu: 'studentList'
                  }
                }
              ]
            },
            {
              path: 'studentAdd',
              name: '新增Leads',
              component: () => import('./views/users/StudentAdd'),
              meta: {
                activeMenu: 'studentAdd'
              }
            }
          ]
        },
        {
          path: 'tuolele',
          name: '托乐乐商学院',
          component: () => import('./views/tuolele/Tuolele'),
          children: [
            {
              path: 'tuoleleIndex',
              name: '商学院',
              component: () => import('./views/tuolele/TuoleleIndex'),
              meta: {
                activeMenu: 'tuoleleIndex'
              }
            },
            {
              path: 'tuoleleCourseDetails',
              name: '资料详情',
              component: () => import('./views/tuolele/TuoleleCourseDetails'),
              meta: {
                activeMenu: 'tuoleleIndex'
              }
            },
            {
              path: 'dataManagement',
              name: '资料管理',
              component: () => import('./views/tuolele/DataManagement'),
              meta: {
                activeMenu: 'dataManagement'
              }
            },
            {
              path: 'dataManagementAdd',
              name: '编辑资料',
              component: () => import('./views/tuolele/DataManagementAdd'),
              meta: {
                activeMenu: 'dataManagement'
              }
            },
            {
              path: 'sortManagement',
              name: '分类管理',
              component: () => import('./views/tuolele/SortManagement'),
              meta: {
                activeMenu: 'sortManagement'
              }
            },
            {
              path: 'sortManagementDetail',
              name: '分类管理详情',
              component: () => import('./views/tuolele/SortManagementDetail'),
              meta: {
                activeMenu: 'sortManagement'
              }
            }
          ]
        },
        // 优豆管理
        {
          path: 'ycoin',
          name: '优豆管理',
          component: () => import('./views/ycoin/ycoin'),
          children: [
            {
              path: 'exchangeCourse',
              name: '兑换课时',
              component: () => import('./views/ycoin/YcoinExchangeCourseManage'),
              meta: {
                activeMenu: 'exchangeCourse'
              }
            },
            {
              path: 'parentRecord',
              name: '家长优豆',
              component: () => import('./views/ycoin/YcoinParentRecord'),
              meta: {
                activeMenu: 'parentRecord'
              }
            }
          ]
        },
        // 系统设置
        {
          path: 'system',
          name: '系统设置',
          component: () => import('./views/system/system'),
          children: [
            {
              path: 'storeSetting',
              name: '店铺管理',
              component: () => import('./views/system/StoreSetting'),
              meta: {
                activeMenu: 'storeSetting'
              }
            },
            {
              path: 'ShopClassList',
              name: '大区管理',
              component: () => import('./views/system/ShopClassList'),
              meta: {
                activeMenu: 'ShopClassList'
              }
            },
            {
              path: 'storeAdd',
              name: '新增/编辑店铺',
              component: () => import('./views/system/StoreAdd'),
              meta: {
                activeMenu: 'storeSetting'
              }
            },
            {
              path: 'foodMenuManage',
              name: '每日食谱',
              component: () => import('./views/system/FoodMenuManage'),
              meta: {
                activeMenu: 'foodMenuManage'
              }
            },
            {
              path: 'foodManage',
              name: '每日食谱',
              component: () => import('./views/system/FoodManage'),
              meta: {
                activeMenu: 'foodManage'
              }
            },
            {
              path: 'addMenu',
              name: '新增/编辑食谱',
              component: () => import('./views/system/AddOrderMenu'),
              meta: {
                activeMenu: 'addMenu'
              }
            },
            {
              path: 'addCompayMenu',
              name: '新增/编辑食谱',
              component: () => import('./views/system/AddCompanyOrderMenu'),
              meta: {
                activeMenu: 'addCompanyOrderMenu'
              }
            },
            {
              path: 'menuOrderList',
              name: '订餐列表',
              component: () => import('./views/system/MenuOrderList'),
              meta: {
                activeMenu: 'menuOrderList'
              }
            },
            {
              path: 'shopMenuOrderList',
              name: '校区订餐',
              component: () => import('./views/system/ShopMenuOrderList'),
              meta: {
                activeMenu: 'shopMenuOrderList'
              }
            },
            {
              path: 'chargeOrderList',
              name: '订餐列表',
              component: () => import('./views/system/ChargeOrderList'),
              meta: {
                activeMenu: 'chargeOrderList'
              }
            },
            {
              path: 'chargeSetting',
              name: '扣费方式设置',
              component: () => import('./views/system/ChargeSetting'),
              meta: {
                activeMenu: 'chargeSetting'
              }
            },
            {
              path: 'companyInformation',
              // name: '公司信息',
              name: '公司合同信息',
              component: () => import('./views/system/CompanyInformation'),
              meta: {
                activeMenu: 'companyInformation'
              }
            },
            {
              path: 'companyArgument',
              name: '合同详情',
              component: () => import('./views/system/CompanyArgument'),
              meta: {
                activeMenu: 'CompanyArgument'
              }
            },
            {
              path: 'calendarSetting',
              name: '人工月设置',
              component: () => import('./views/system/CalendarSetting'),
              meta: {
                activeMenu: 'calendarSetting'
              }
            },
            {
              path: 'paymentSetting',
              name: '支付设置',
              component: () => import('./views/system/PaymentSetting'),
              meta: {
                activeMenu: 'paymentSetting'
              }
            },
            {
              path: 'paymentAppManageSetting',
              name: '支付渠道',
              component: () => import('./views/system/PaymentAppManageSetting'),
              meta: {
                activeMenu: 'paymentAppManageSetting'
              }
            },
            {
              path: 'paymentAppChannelSetting',
              name: '渠道配置',
              component: () => import('./views/system/PaymentAppChannelSetting'),
              meta: {
                activeMenu: 'paymentAppChannelSetting'
              }
            },
            {
              path: 'paymentShopBindSetting',
              name: '支付渠道配置',
              component: () => import('./views/system/PaymentShopBindSetting'),
              meta: {
                activeMenu: 'paymentShopBindSetting'
              }
            },
            {
              path: 'paymentAlipay',
              name: '支付管理',
              component: () => import('./views/system/paymentAlipay'),
              meta: {
                activeMenu: 'paymentSetting'
              }
            },
            {
              path: 'wechatSetting',
              name: '微信设置',
              component: () => import('./views/system/WechatSetting'),
              meta: {
                activeMenu: 'wechatSetting'
              }
            },
            {
              path: 'accountManagement',
              name: '账号管理',
              component: () => import('./views/system/AccountManagement'),
              children: [],
              meta: {
                activeMenu: 'accountManagement'
              }
            },
            {
              path: 'companySetting',
              name: '公司配置',
              component: () => import('./views/system/CompanySetting'),
              meta: {
                activeMenu: 'companySetting'
              }
            },
            {
              path: 'accountAdd',
              name: '新增账号',
              component: () => import('./views/system/AccountAdd'),
              meta: {
                activeMenu: 'accountManagement'
              }
            },
            {
              path: 'pickUpSetting',
              name: '接校设置',
              component: () => import('./views/system/PickUpSetting'),
              meta: {
                activeMenu: 'pickUpSetting'
              }
            },
            {
              path: 'educationalSetting',
              name: '教务设置',
              component: () => import('./views/system/EducationalSetting'),
              meta: {
                activeMenu: 'educationalSetting'
              }
            },
            {
              path: 'serviceSetting',
              name: '增值服务',
              component: () => import('./views/system/ServiceSetting'),
              meta: {
                activeMenu: 'serviceSetting'
              }
            },
            {
              path: 'accountFinancial',
              name: '账户管理',
              component: () => import('./views/system/AccountFinancial'),
              meta: {
                activeMenu: 'accountFinancial'
              }
            },
            {
              path: 'companyManage',
              name: '公司管理',
              component: () => import('./views/system/CompanyManage'),
              meta: {
                activeMenu: 'companyManage'
              }
            },
            {
              path: 'companyAdd',
              name: '新增/编辑公司',
              component: () => import('./views/system/CompanyAdd'),
              meta: {
                activeMenu: 'companyManage'
              }
            },
            {
              path: 'gradeSetting',
              name: '通用设置',
              component: () => import('./views/system/GradeSetting'),
              meta: {
                activeMenu: 'gradeSetting'
              }
            }
          ]
        },
        {
          path: 'order',
          name: '订单管理',
          component: () => import('./views/order/Order'),
          children: [
            {
              path: 'orderSigning',
              name: '托乐乐-签约查询',
              component: () => import('./views/order/OrderSigning'),
              meta: {
                activeMenu: 'orderSigning'
              }
            },
            {
              path: 'orderRefund',
              name: '托乐乐-退款查询',
              component: () => import('./views/order/OrderRefund'),
              meta: {
                activeMenu: 'orderRefund'
              }
            },
            {
              path: 'orderConverted',
              name: '内转查询',
              component: () => import('./views/order/OrderConverted'),
              meta: {
                activeMenu: 'orderConverted'
              }
            },
            {
              path: 'orderSigningAudit',
              name: '财务签约审核',
              component: () => import('./views/order/OrderSigningAudit'),
              meta: {
                activeMenu: 'orderSigningAudit'
              }
            },
            {
              path: 'ttpdOrderSigningAudit',
              name: '天天陪读-签约查询',
              component: () => import('./views/order/TTPDOrderSigningAudit'),
              meta: {
                activeMenu: 'ttpdOrderSigningAudit'
              }
            },
            {
              path: 'ttpdOrderRefundAudit',
              name: '天天陪读-退款查询',
              component: () => import('./views/order/TTPDOrderRefundAudit'),
              meta: {
                activeMenu: 'ttpdOrderRefundAudit'
              }
            },
            {
              path: 'orderRefundAudit',
              name: '财务退款审核',
              component: () => import('./views/order/OrderRefundAudit'),
              meta: {
                activeMenu: 'orderRefundAudit'
              }
            },
            {
              path: 'orderConvertedAudit',
              name: '财务内转审核',
              component: () => import('./views/order/OrderConvertedAudit'),
              meta: {
                activeMenu: 'orderConvertedAudit'
              }
            },
            {
              path: 'orderGiveAudit',
              name: '总部赠送审核',
              component: () => import('./views/order/OrderGiveAudit'),
              meta: {
                activeMenu: 'orderGiveAudit'
              }
            },
            {
              path: 'FrianceLists',
              name: '家长提现审核',
              component: () => import('./views/friance/FrianceLists'),
              meta: {
                activeMenu: 'frianceLists'
              }
            },
            {
              path: 'tgbOrderAudit',
              name: '托管宝财务审核',
              component: () => import('./views/order/TgbRechargeAudit'),
              meta: {
                activeMenu: 'tgbOrderAudit'
              }
            },
            {
              path: 'tgbInvoiceAudit',
              name: '托管宝发票审核',
              component: () => import('./views/friance/TGBInvoiceAudit'),
              meta: {
                activeMenu: 'tgbInvoiceAudit'
              }
            }
          ]
        },
        {
          path: 'tiyouyou',
          name: '题优优',
          component: () => import('./views/tiyouyou/TiYouYou'),
          children: [
            {
              path: 'tiyouyouPackageList',
              name: '套餐列表',
              component: () => import('./views/tiyouyou/tiyouyouPackageList'),
              meta: {
                activeMenu: 'tiyouyouPackageList'
              }
            },
            {
              path: 'tiyouyouParentsBook',
              name: '日程任务管理',
              component: () => import('./views/tiyouyou/tiyouyouParentsBook'),
              meta: {
                activeMenu: 'tiyouyouParentsBook'
              }
            },
            {
              path: 'tiyouyouAddPakcage',
              name: '添加套餐',
              component: () => import('./views/tiyouyou/tiyouyouAddPakcage'),
              meta: {
                activeMenu: 'tiyouyouAddPakcage'
              }
            },
            {
              path: 'tiyouyouAddParentsBook',
              name: '创建/编辑家长宝典',
              component: () => import('./views/tiyouyou/tiyouyouAddParentsBook'),
              meta: {
                activeMenu: 'tiyouyouAddParentsBook'
              }
            },
            {
              path: 'tyyLiveSettingLists',
              name: '直播活动管理',
              component: () => import('./views/tiyouyou/tyyLiveSettingLists'),
              meta: {
                activeMenu: 'tyyLiveSettingLists'
              }
            },
            {
              path: 'tiyouyouAddLive',
              name: '创建直播活动',
              component: () => import('./views/tiyouyou/tiyouyouAddLive'),
              meta: {
                activeMenu: 'tiyouyouAddLive'
              }
            },
            {
              path: 'tyyKnowledgeSettingLists',
              name: '知识点管理',
              component: () => import('./views/tiyouyou/tyyKnowledgeSettingLists'),
              meta: {
                activeMenu: 'tyyKnowledgeSettingLists'
              }
            },
            {
              path: 'tiyouyouAddKnowledge',
              name: '创建/编辑知识点',
              component: () => import('./views/tiyouyou/tiyouyouAddKnowledge'),
              meta: {
                activeMenu: 'tiyouyouAddKnowledge'
              }
            },
            {
              path: 'tyyLiveAppointmentLists',
              name: '直播预约记录',
              component: () => import('./views/tiyouyou/tyyLiveAppointmentLists'),
              meta: {
                activeMenu: 'tyyLiveAppointmentLists'
              }
            },
            {
              path: 'tyyOrderSignList',
              name: '签约订单',
              component: () => import('./views/tiyouyou/tyyOrderSignList'),
              meta: {
                activeMenu: 'tyyOrderSignList'
              }
            },
            {
              path: 'tiyouyouStudentList',
              name: '题优优学生列表',
              component: () => import('./views/tiyouyou/tiyouyouStudentList'),
              meta: {
                activeMenu: 'tiyouyouStudentList'
              }
            },
            {
              path: 'tyyScoreList',
              name: '积分变动',
              component: () => import('./views/tiyouyou/tyyScoreList'),
              meta: {
                activeMenu: 'tyyScoreList'
              }
            },
            {
              path: 'tyyDoubleTestRecord',
              name: '双周测评记录',
              component: () => import('./views/tiyouyou/tyyDoubleTestRecord'),
              meta: {
                activeMenu: 'tyyDoubleTestRecord'
              }
            },
            {
              path: 'tyyOrderRefundLists',
              name: '退费订单',
              component: () => import('./views/tiyouyou/tyyOrderRefundLists'),
              meta: {
                activeMenu: 'tyyOrderRefundLists'
              }
            },
            {
              path: 'tyyOrderRefundLearningAuditing',
              name: '学习管家审核',
              component: () => import('./views/tiyouyou/tyyOrderRefundAuditing'),
              props: (route) => ({ query: route.query.status }),
              meta: {
                activeMenu: 'tyyOrderRefundLearningAuditing'
              }
            },
            {
              path: 'tyyOrderRefundCompanyAuditing',
              name: '总部审核',
              component: () => import('./views/tiyouyou/tyyOrderRefundAuditing'),
              props: (route) => ({ query: route.query.status }),
              meta: {
                activeMenu: 'tyyOrderRefundCompanyAuditing'
              }
            },
            {
              path: 'tyyOrderRefundFinanceAuditing',
              name: '财务审核',
              component: () => import('./views/tiyouyou/tyyOrderRefundAuditing'),
              props: (route) => ({ query: route.query.status }),
              meta: {
                activeMenu: 'tyyOrderRefundFinanceAuditing'
              }
            },
            {
              path: 'tyyPractiseTestRecord',
              name: '练习记录',
              component: () => import('./views/tiyouyou/tyyPractiseTestRecord'),
              meta: {
                activeMenu: 'tyyPractiseTestRecord'
              }
            },
            {
              path: 'tyyRevenueStatics',
              name: '营收数据',
              component: () => import('./views/tiyouyou/tyyRevenueStatics'),
              meta: {
                activeMenu: 'tyyRevenueStatics'
              }
            },
            {
              path: 'tyyBusinessStatics',
              name: '运营数据',
              component: () => import('./views/tiyouyou/tyyBusinessStatics'),
              meta: {
                activeMenu: 'tyyBusinessStatics'
              }
            }
          ]
        },
        // 总部监管
        {
          path: 'headquarters',
          name: '总部监管',
          component: () => import('./views/headquarters/Headquarters'),
          children: [
            {
              path: 'targetAndPlan',
              name: '目标计划',
              component: () => import('./views/headquarters/TargetAndPlan'),
              meta: {
                activeMenu: 'targetAndPlan'
              }
            },
            {
              path: 'warningStudent',
              name: '未回访预警学员',
              component: () => import('./views/headquarters/WarningStudentLists'),
              meta: {
                activeMenu: 'warningStudent'
              }
            },
            {
              path: 'targetData',
              name: '目标计划数据',
              component: () => import('./views/headquarters/TargetData'),
              meta: {
                activeMenu: 'targetAndPlan'
              }
            },
            {
              path: 'opinionLists',
              name: '员工意见',
              component: () => import('./views/headquarters/OpinionLists'),
              meta: {
                activeMenu: 'opinionLists'
              }
            },
            {
              path: 'goldOptions',
              name: '员工意见',
              component: () => import('./views/headquarters/GoldOptions'),
              meta: {
                activeMenu: 'goldOptions'
              }
            },
            {
              path: 'questionnaireLists',
              name: '问卷调查',
              component: () => import('./views/headquarters/QuestionnaireLists'),
              meta: {
                activeMenu: 'questionnaireLists'
              }
            },
            {
              path: 'questionnaireAnalysis',
              name: '问卷分析',
              component: () => import('./views/headquarters/QuestionnaireAnalysis'),
              meta: {
                activeMenu: 'questionnaireAnalysis'
              }
            },
            {
              path: 'questionnaireDetail',
              name: '创建/编辑问卷',
              component: () => import('./views/headquarters/QuestionnaireDetail'),
              meta: {
                activeMenu: 'questionnaireDetail'
              }
            },
            {
              path: 'turnStudentList',
              name: '转介绍记录',
              component: () => import('./views/headquarters/turnStudentList'),
              meta: {
                activeMenu: 'turnStudentList'
              }
            },
            {
              path: 'scheduleList',
              name: '课表管理',
              component: () => import('./views/headquarters/scheduleList'),
              meta: {
                activeMenu: 'scheduleList'
              }
            },
            {
              path: 'courseList',
              name: '课程内容配置',
              component: () => import('./views/headquarters/courseList'),
              meta: {
                activeMenu: 'courseList'
              }
            },
            {
              path: 'reportDailyLists',
              name: '学员日报',
              component: () => import('./views/headquarters/ReportDailyLists'),
              meta: {
                activeMenu: 'reportDailyLists'
              }
            },
            {
              path: 'resumeCoruseLists',
              name: '复课记录',
              component: () => import('./views/headquarters/ResumeCourseStatusLists'),
              meta: {
                activeMenu: 'resumeCoruseLists'
              }
            },
            {
              path: 'reportDailyLists',
              name: '学员日报',
              component: () => import('./views/headquarters/ReportDailyLists'),
              meta: {
                activeMenu: 'reportDailyLists'
              }
            }
          ]
        },
        {
          path: 'operation',
          name: '总部运营',
          component: () => import('./views/operation/Operation'),
          children: [
            {
              path: 'orderConvertLists',
              name: '业务课时转换',
              component: () => import('./views/operation/OrderConvertLists'),
              meta: {
                activeMenu: 'orderConvertLists'
              }
            }
          ]
        },
        {
          path: 'combo',
          name: '套餐管理',
          component: () => import('./views/combo/Combo'),
          children: [
            {
              path: 'comboList',
              name: '套餐列表',
              component: () => import('./views/combo/ComboList'),
              meta: {
                activeMenu: 'comboList'
              }
            },
            {
              path: 'addCombo',
              name: '新增套餐',
              component: () => import('./views/combo/AddCombo'),
              meta: {
                activeMenu: 'comboList'
              }
            },
            {
              path: 'setCombo',
              name: '套餐配置',
              component: () => import('./views/combo/SetCombo'),
              meta: {
                activeMenu: 'setCombo'
              }
            },
            {
              path: 'comboGroup',
              name: '套餐分组',
              component: () => import('./views/combo/ComboGroup'),
              meta: {
                activeMenu: 'comboGroup'
              }
            },
            {
              path: 'editGroup',
              name: '编辑分组',
              component: () => import('./views/combo/EditGroup'),
              meta: {
                activeMenu: 'comboGroup'
              }
            }
          ]
        },
        {
          path: 'stock',
          name: '猫头鹰股金',
          component: () => import('./views/stock/Stock'),
          children: [
            {
              path: 'stockExerciseList',
              name: '行权周期',
              component: () => import('./views/stock/StockExerciseList'),
              meta: {
                activeMenu: 'stockExerciseList'
              }
            },
            {
              path: 'waitSendStockLists',
              name: '发放股金',
              component: () => import('./views/stock/WaitSendStockLists'),
              meta: {
                activeMenu: 'waitSendStockLists'
              }
            },
            {
              path: 'stockExerciseExchangeLists',
              name: '交易明细',
              component: () => import('./views/stock/StockExerciseExchangeLists'),
              meta: {
                activeMenu: 'stockExerciseExchangeLists'
              }
            },
            {
              path: 'stockPriceHistoryList',
              name: '历史股份',
              component: () => import('./views/stock/StockPriceHistoryList'),
              meta: {
                activeMenu: 'stockPriceHistoryList'
              }
            },
            {
              path: 'employeeStockHistoryLists',
              name: '员工股金',
              component: () => import('./views/stock/EmployeeStockHistoryLists'),
              meta: {
                activeMenu: 'employeeStockHistoryLists'
              }
            }
          ]
        },
        {
          path: 'quality',
          name: '质检管理',
          component: () => import('./views/quality/Quality'),
          children: [
            {
              path: 'qualityItemManager',
              name: '质检项目',
              component: () => import('./views/quality/qualityItemManager'),
              meta: {
                activeMenu: 'qualityItemManager'
              }
            },
            {
              path: 'qualityCheckList',
              name: '质检记录',
              component: () => import('./views/quality/qualityCheckList'),
              meta: {
                activeMenu: 'qualityCheckList'
              }
            }

          ]
        },
        {
          path: 'statistics',
          name: '数据统计',
          component: () => import('./views/statistics/Statistics'),
          children: [
            {
              path: 'dailyStatistics',
              name: '日常统计',
              component: () => import('./views/statistics/DailyStatistics'),
              meta: {
                activeMenu: 'dailyStatistics'
              }
            },
            {
              path: 'salesStatistics',
              name: '销售统计',
              component: () => import('./views/statistics/SalesStatistics'),
              meta: {
                activeMenu: 'salesStatistics'
              }
            },
            {
              path: 'admissionsStatistics',
              name: '招生统计',
              component: () =>
                import('./views/statistics/AdmissionsStatistics'),
              meta: {
                activeMenu: 'admissionsStatistics'
              }
            },
            {
              path: 'channelStatistics',
              name: '渠道统计',
              component: () => import('./views/statistics/ChannelStatistics'),
              meta: {
                activeMenu: 'channelStatistics'
              }
            },
            {
              path: 'campusStatistics',
              name: '校区运营',
              component: () => import('./views/statistics/CampusStatistics'),
              meta: {
                activeMenu: 'campusStatistics'
              }
            },
            {
              path: 'correctStatistics',
              name: '批改张数统计',
              component: () => import('./views/statistics/CorrectStatistics'),
              meta: {
                activeMenu: 'correctStatistics'
              }
            },
            {
              path: 'downloadReport',
              name: '导出数据CSV',
              component: () => import('./views/statistics/DownloadReport'),
              meta: {
                activeMenu: 'downloadReport'
              }
            },
            {
              path: 'teacherStatistics',
              name: '班主任',
              component: () => import('./views/statistics/TeacherStatistics'),
              meta: {
                activeMenu: 'teacherStatistics'
              }
            },
            {
              path: 'salesmanStatistics',
              name: '销售人员',
              component: () => import('./views/statistics/SalesmanStatistics'),
              meta: {
                activeMenu: 'salesmanStatistics'
              }
            },
            {
              path: 'marketStatistics',
              name: '市场人员',
              component: () => import('./views/statistics/MarketStatistics'),
              meta: {
                activeMenu: 'marketStatistics'
              }
            }
          ]
        },
        {
          path: 'active',
          name: '活动管理',
          component: () => import('./views/active/Active'),
          children: [
            {
              path: 'activeYX',
              name: '游学活动',
              component: () => import('./views/active/activeYX'),
              meta: {
                activeMenu: 'activeYX'
              }
            },
            {
              path: 'activeLucky',
              name: '抽奖管理',
              component: () => import('./views/active/activeLucky'),
              meta: {
                activeMenu: 'activeLucky'
              }
            },
            {
              path: 'activeAwardLists',
              name: '奖品列表',
              component: () => import('./views/active/activeAwardLists'),
              meta: {
                activeMenu: 'activeAwardLists'
              }
            },
            {
              path: 'activeYXStudentLists',
              name: '游学报名列表',
              component: () => import('./views/active/activeYXStudentLists'),
              meta: {
                activeMenu: 'activeYXStudentLists'
              }
            },
            {
              path: 'activeLuckyStudentLists',
              name: '抽奖用户',
              component: () => import('./views/active/activeLuckyStudentLists'),
              meta: {
                activeMenu: 'activeLuckyStudentLists'
              }
            },
            {
              path: 'activeLuckyCorrectLists',
              name: '中奖记录',
              component: () => import('./views/active/activeLuckyCorrectLists'),
              meta: {
                activeMenu: 'activeLuckyCorrectLists'
              }
            },
            {
              path: 'activeExchangeRecord',
              name: '游学报名列表',
              component: () => import('./views/active/activeExchangeRecordLists'),
              meta: {
                activeMenu: 'activeExchangeRecord'
              }
            }
          ]
        },
        {
          path: 'homework',
          name: '题目管理',
          component: () => import('./views/homework/Homework'),
          children: [
            {
              path: 'HomeWorkLists',
              name: '练习列表',
              component: () => import('./views/homework/HomeWorkLists'),
              meta: {
                activeMenu: 'homeWorkLists'
              }
            },
            {
              path: 'createHomeWork',
              name: '创建练习',
              component: () => import('./views/homework/CreateHomeWork'),
              meta: {
                activeMenu: 'createHomeWork'
              }
            }
          ]
        },
        {
          path: 'points',
          name: '积分管理',
          component: () => import('./views/points/Points'),
          children: [
            {
              path: 'pointRewardPunishmentsLists',
              name: '积分奖惩列表',
              component: () => import('./views/points/PointRewardPunishmentsLists'),
              meta: {
                activeMenu: 'pointRewardPunishmentsLists'
              }
            },
            {
              path: 'pointManage',
              name: '积分管理列表',
              component: () => import('./views/points/PointManageLists'),
              meta: {
                activeMenu: 'pointManage'
              }
            },
            {
              path: 'scoreLists',
              name: '积分流水',
              component: () => import('./views/points/PointScoreLists'),
              meta: {
                activeMenu: 'scoreLists'
              }
            }
          ]
        },
        {
          path: 'purchase',
          name: '采购管理',
          component: () => import('./views/purchase/Purchase'),
          children: [
            {
              path: 'purchaseLists',
              name: '物品管理',
              component: () => import('./views/purchase/PurchaseManage'),
              meta: {
                activeMenu: 'purchaseLists'
              }
            },
            {
              path: 'purchaseSwitch',
              name: '采购开关',
              component: () => import('./views/purchase/PurchaseSwitch'),
              meta: {
                activeMenu: 'purchaseSwitch'
              }
            },
            {
              path: 'purchaseAudit',
              name: '采购审核',
              component: () => import('./views/purchase/PurchaseAudit'),
              meta: {
                activeMenu: 'purchaseAudit'
              }
            },
            {
              path: 'purchaseWaitReceive',
              name: '包裹待确认收货',
              component: () => import('./views/purchase/PurchaseWaitReceive'),
              meta: {
                activeMenu: 'purchaseWaitReceive'
              }
            },
            {
              path: 'purchaseUpdateExpress',
              name: '未填写包裹信息',
              component: () => import('./views/purchase/PurchaseUpdateExpress'),
              meta: {
                activeMenu: 'purchaseUpdateExpress'
              }
            },
            {
              path: 'purchaseShopManage',
              name: '校区库存管理',
              component: () => import('./views/purchase/PurchaseShopManage'),
              meta: {
                activeMenu: 'purchaseShopManage'
              }
            }
          ]
        },
        {
          path: 'otherproduct',
          name: '套餐外费用管理',
          component: () => import('./views/otherproduct/index'),
          children: [
            {
              path: 'otherType',
              name: '类别管理',
              component: () => import('./views/otherproduct/OtherType'),
              meta: {
                activeMenu: 'otherType'
              }
            },
            {
              path: 'otherPrice',
              name: '费用管理',
              component: () => import('./views/otherproduct/OtherPriceManage'),
              meta: {
                activeMenu: 'otherPrice'
              }
            }

          ]
        },
        {
          path: 'discount',
          name: '优惠管理',
          component: () => import('./views/discount/index'),
          children: [
            {
              path: 'CouponManage',
              name: '优惠卷管理',
              component: () => import('./views/discount/CouponManage'),
              meta: {
                activeMenu: 'couponManage'
              }
            },
            {
              path: 'createCoupon',
              name: '新增优惠',
              component: () => import('./views/discount/CreateCoupon'),
              meta: {
                activeMenu: 'createCoupon'
              }
            }

          ]
        }
      ]
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.matched.length === 0) {
    from.name ? next({ name: from.name }) : next('/admin')
  } else {
    next()
  }
  const userInfo = localStorage.userInfo
  if (userInfo || to.name === 'login') {
    next()
  } else {
    next({
      name: 'login',
      query: {
        redirect: to.path
      }
    })
  }
})

export default router
